export default {"src":"/_next/static/media/CarValueTrackerCategory.f2d62dfa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};